<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  created() {
    if(window.location.href.includes("cardtest.sabinarya.com") ){
      window.location.replace("https://cardapi.sabinarya.com/login")
    }
  }
}
</script>

